import React, { useMemo } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine, Area, AreaChart } from 'recharts';
import { formatDistance } from '../lib/locale';

export default function SocGraph({ trace, locale, height = 140 }) {
  const data = useMemo(() => {
    if (!trace?.points?.length) return [];
    return trace.points.map(p => ({
      km: p.distance_km,
      soc: Number(p.soc_pct.toFixed(1)),
    }));
  }, [trace]);
  
  if (!data.length) {
    return (
      <div style={{
        height,
        background: 'var(--bg-card)',
        border: '0.5px solid var(--border-subtle)',
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--text-tertiary)',
        fontSize: 12,
        marginBottom: 12,
      }}>
        No SoC data
      </div>
    );
  }
  
  return (
    <div style={{
      height,
      background: 'var(--bg-card)',
      border: '0.5px solid var(--border-subtle)',
      borderRadius: 12,
      padding: '12px 8px 8px',
      marginBottom: 12,
    }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 4, right: 8, left: -10, bottom: 0 }}>
          <defs>
            <linearGradient id="socFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#20d9a6" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#20d9a6" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="km"
            tick={{ fill: '#777', fontSize: 10 }}
            axisLine={{ stroke: '#2a2a2a' }}
            tickLine={false}
            tickFormatter={(v) => formatDistance(v, locale, { showUnit: false })}
          />
          <YAxis
            domain={[0, 100]}
            tick={{ fill: '#777', fontSize: 10 }}
            axisLine={{ stroke: '#2a2a2a' }}
            tickLine={false}
            tickFormatter={(v) => `${v}%`}
            width={30}
          />
          <ReferenceLine y={20} stroke="#ff5757" strokeDasharray="2 3" strokeOpacity={0.4} />
          <Tooltip
            contentStyle={{
              background: '#0a0a0a',
              border: '0.5px solid #2a2a2a',
              borderRadius: 8,
              fontSize: 12,
              color: '#fff',
            }}
            labelFormatter={(v) => formatDistance(v, locale)}
            formatter={(v) => [`${v}%`, 'SoC']}
          />
          <Area
            type="monotone"
            dataKey="soc"
            stroke="#20d9a6"
            strokeWidth={2}
            fill="url(#socFill)"
            dot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
